export default "__VITE_ASSET__BTMyRFet__"